export const GET_IMAGE_ATTEMPT = 'GET_IMAGE_ATTEMPT';
export type GET_IMAGE_ATTEMPT = typeof GET_IMAGE_ATTEMPT;

export const GET_IMAGE_SUCCESS = 'GET_IMAGE_SUCCESS';
export type GET_IMAGE_SUCCESS = typeof GET_IMAGE_SUCCESS;

export const GET_IMAGE_FAILURE = 'GET_IMAGE_FAILURE';
export type GET_IMAGE_FAILURE = typeof GET_IMAGE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/image/get/Types.tsx